const stats = [
  { value: "128", label: "今日新料" },
  { value: "36", label: "跟进中事件" },
  { value: "2.4k", label: "材料库条目" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dark%20editorial%20backdrop%20with%20deep%20charcoal%20and%20black%20texture%2C%20warm%20crimson%20and%20amber%20light%20streaks%20sweeping%20diagonally%20across%20the%20frame%2C%20subtle%20film%20grain%2C%20dramatic%20moody%20atmosphere%2C%20high%20contrast%20negative%20space%20for%20overlaid%20headline%20text%2C%20cinematic%20studio%20lighting%2C%20no%20people%2C%20no%20text&width=1920&height=1080&seq=heiliao-hero-primary&orientation=landscape"
        alt="黑料bu 爆料直达主视觉背景"
        title="黑料bu 爆料直达 新料入口"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/85"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 pb-20 pt-32 text-center md:px-8 md:pb-28 md:pt-44">
        <span className="hl-fade-up mb-6 inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium tracking-[0.2em] text-accent-300 md:text-sm">
          <i className="ri-fire-line"></i>
          爆料直达 · 新料入口
        </span>

        <h1 className="hl-fade-up hl-delay-1 font-heading text-6xl font-black leading-none tracking-tight text-background-50 md:text-8xl lg:text-9xl">
          黑料bu
        </h1>

        <p className="hl-fade-up hl-delay-2 mt-6 font-heading text-2xl font-semibold text-background-50 md:text-4xl">
          最新爆料通道，点开即看
        </p>

        <p className="hl-fade-up hl-delay-3 mt-5 max-w-2xl text-sm leading-loose text-background-100/85 md:text-base">
          黑料bu爆料入口聚合最新事件线索与深挖材料，直达热门瓜点。想第一时间掌握黑料bu新料入口、跟进爆料后续，这里持续更新，点开即看。
        </p>

        <div className="hl-fade-up hl-delay-3 mt-9 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row">
          <a
            href="#feed"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-flashlight-line text-base"></i>
            查看最新爆料
          </a>
          <a
            href="#rank"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-8 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:border-background-50 hover:bg-background-50/10 sm:w-auto"
          >
            <i className="ri-bar-chart-2-line text-base"></i>
            浏览热度榜
          </a>
        </div>

        <div className="hl-fade-up hl-delay-4 mt-16 grid w-full max-w-2xl grid-cols-3 divide-x divide-background-50/20 border-y border-background-50/20 py-6">
          {stats.map((item) => (
            <div key={item.label} className="px-2">
              <p className="font-heading text-2xl font-black text-background-50 md:text-4xl">{item.value}</p>
              <p className="mt-1 text-xs tracking-wide text-background-100/70 md:text-sm">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}